'use es6';

import { Record } from 'immutable';
const ExitIntentTrigger = new Record({
  enabled: false
}, 'ExitIntentTrigger');
export default ExitIntentTrigger;